import { IgToggleButtonGroup } from "@intelligems/ig-theme/IgToggleButtonGroup";
import { styled } from "@mui/material/styles";

export const ToggleButtonGroup = styled(IgToggleButtonGroup)(({ theme }) => ({
  backgroundColor: theme.igBackgroundColors.baseLightMid,
  border: `1px solid ${theme.igBorders.core.default}`,
  borderRadius: "6px",
  padding: "3px",
  gap: "2px",
  height: "32px",
  width: "fit-content",
  "& .MuiToggleButtonGroup-grouped": {
    border: "none",
    borderRadius: "4px !important",
    padding: "2px 8px",
    gap: "8px",
    fontSize: "12px",
    fontWeight: "400",
    "&.Mui-selected": {
      backgroundColor: theme.igBackgroundColors.interactive.neutral.active,
      fontWeight: "500",
      "&:hover": {
        backgroundColor: theme.palette.common.white,
      },
    },
    "&.Mui-disabled": {
      opacity: 0.5,
      cursor: "not-allowed",
      color: theme.palette.action.disabled,
    },
  },
}));
